const palette = {
  colors: [
    '#5E77FF',
    '#9C60FE',
    '#F162FE',
    '#FD65B7',
    '#FD6768',
    '#FDB86A',
    '#F2FC6C',
    '#A5FC6E',
    '#71FB85',
    '#73FBD0',
    '#76DDFA',
    '#76f4fa',
    '#bb76fa',
    '#fa76bf'
  ]
};

export default palette;